import { ApiUrls } from "../../Services/apiUrls";
import axios from "axios";

export const getAllSectorsApi = () => {
  return axios
    .get(ApiUrls.Sectors.getAll)
    .then(({ data }) => data)
    .catch((response) => response);
};

export const saveSectorApi = (sector) => {
  return axios
    .post(ApiUrls.Sectors.save, sector)
    .then(({ data }) => data)
    .catch((response) => response);
};

export const updateUserSectorApi = (userId, sectorId) => {
  return axios
    .put(ApiUrls.Sectors.updateUserSector(userId, sectorId))
    .then(({ data }) => data)
    .catch((response) => response);
};

export const getAllIndustriesApi = () => {
  return axios
    .get(ApiUrls.Sectors.allIndustries)
    .then(({ data }) => data)
    .catch((response) => response);
};
